import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { Card } from "./Card";
import { CardHeader } from "./CardHeader";
import { CardIcon } from "./CardIcon";
import { CardFooter } from "./CardFooter";
import Icon from "@material-ui/core/Icon";
import styles from "@/components/AlertCard/dashboardStyle";

interface IProps {
  icon: string;
  title: string;
  color: "warning" | "success" | "danger" | "info" | "primary" | "rose";
  smallIcon: JSX.Element;
  description: string;
}

export const AlertCard: FC<IProps> = ({ color, description, icon, title, children, smallIcon }) => {
  // @ts-ignore
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <Card className="alertcard">
      <CardHeader color={color} stats icon className="cardheader">
        <CardIcon color={color} className="cardIcon">
          <Icon>{icon}</Icon>
        </CardIcon>
        <p className={classes.cardCategory}>{title}</p>
        {children}
      </CardHeader>
      <CardFooter stats className="cardfooter">
        <div className={classes.stats}>
          {smallIcon}
          <a href="#" onClick={e => e.preventDefault()}>
            {description}
          </a>
        </div>
      </CardFooter>
    </Card>
  );
};
